import {openModalConfirmRemove} from 'js/services/modals.js'

import template from './alert-campaign.pug'
import BasicInfoForm from '../../wizard/basic-info.js'

export default Vue.extend({
  template: template(),
  components: {
    BasicInfoForm
  },
  props: {
    campaign: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      active:true,
      emails: [],
      emailInput: '',
      msg: '',
      time:45,
      data: {},
      startDate: this.campaign.startAt,
      errors: {}
    }
  },
  watch: {
      initData: {
      immediate: true,
      handler() {
        this.initializeData(),
        this.getAlertCampaign()       
      }
    },
  }, 
  methods: {
    t(key, options = {}) {
      return this.$t(`campaigns.show.config.tabs.alertCampaign.${key}`, options)
    },

      initializeData() {
        const data = {}
        data.active = false
        data.alertSetting = {}
        data.alertSetting.to = []      
        data.alertSetting.time = 0
        this.data = data
      },

    confirmSave() {
      openModalConfirmRemove(
        this.t('saveConfirmationModal.title'),
        '',
        this.t('saveConfirmationModal.okButton')
      ).then(() => {
        this.save()
      })
    },

     addEmailInput() {
      if (/^[\w-\.]+@([\w-]+\.)+[\w-]{2,4}$/.test(this.emailInput)) {
        this.data.alertSetting.to.push({email: this.emailInput})
        this.emailInput = ''
        this.msg = ''
      } else {
        this.msg = this.t('emailError')
      }
    },
    removeEmailInput(index) {
      this.data.alertSetting.to.splice(index, 1)
    },
    
  

     getAlertCampaign() {
      return API.campaigns.alerts.index(this.$route.params.id,'inactivity-lead').then(({data}) => {       
       this.data = data
      })
    },


    save() {
      console.log(this.data);      
      API.campaigns.alerts.update(this.$route.params.id,'inactivity-lead', this.data).then(() => {
        this.$notifications.success(this.t('succesfullyUpdated'))
        this.errors = {}
      }, errors => {
        this.errors = errors
      })
    }
  }
})
